export default {
    en: {
        number: 2,
        diagramId: 1,
        answers: 'Neither boxers nor epileptics can remember both can remember',
        interactiveBoxNumber: [1],
        blocks:
            [
                {
                    task: {
                        question: 'Neither boxers nor epileptics can remember events immediately before a blow or a seizure',
                        answer: '<span class="correct-answer-box"><span class="highlight__answer highlight__answer_correct">Neither boxers nor epileptics can remember</span> events immediately before a blow or a seizure</span>'
                    },
                    example: true
                },
                {
                    task: {
                        question: 'But both can remember much earlier events',
                        answer: '<span class="correct-answer-box">But <span class="highlight__answer highlight__answer_correct">both can remember</span> much earlier events</span>'
                    },
                    selectAvailable: true
                },
                {
                    task: {
                        question: 'Suggests people need time to consolidate short-term memories before entering them into long-term storage',
                        answer: '<span class="correct-answer-box">Suggests people need time to consolidate short-term memories before entering them into long-term storage</span>'
                    }
                }
            ]
    }
};



// WEBPACK FOOTER //
// ./client/app/modules/courses/3/3a1/deductiveReasoning/i18n/exercise2.js